import React, { useEffect, useState } from "react";
import HeroSection from "./HeroSection";
import Expertise from "./Expertise";
import ApplySection from "./ApplySection";
import HiringSolutions from "./HiringSolutions";
import BusinessSectors from "./BusinessSectors";
import FindTalentSection from "./FindTalentSection";
import ClientsTrustSection from "./ClientsTrustSection";
import GlobalRecruitment from "./GlobalRecruitment";
import HappyClients from "./Testinomial";
import { useHomeScript } from "./HomeScript";
import { getMetadataByPage, FILE_URL } from "../../API/Api";
import { Helmet } from "react-helmet-async";

const Home = () => {
  const [metadata, setMetadata] = useState(null);

  useEffect(() => {
    const fetchMetadata = async () => {
      const data = await getMetadataByPage("home");
      setMetadata(data);
    };
    fetchMetadata();
  }, []);
  useHomeScript();
  return (
    <>
      {metadata && (
        <Helmet>
          <title>{metadata?.title || "Anaxistech"}</title>
          <meta
            name="description"
            content={metadata?.description || "Default description"}
          />
          <meta
            name="keywords"
            content={metadata?.keywords || "tech, services"}
          />
          <meta
            property="og:title"
            content={metadata?.ogTitle || metadata?.title || "Anaxistech"}
          />
          <meta
            property="og:description"
            content={
              metadata?.ogDescription ||
              metadata?.description ||
              "Default description"
            }
          />
          <meta
            property="og:image"
            content={metadata?.ogImage ? `${FILE_URL}${metadata.ogImage}` : "/default-image.png"}
          />
          <meta
            property="og:url"
            content={metadata?.ogUrl || window.location.href}
          />
        </Helmet>
      )}
      <HeroSection />
      <Expertise />
      <ApplySection />
      <HiringSolutions />
      <BusinessSectors />
      <FindTalentSection />
      <ClientsTrustSection />
      <GlobalRecruitment />
      <HappyClients />
    </>
  );
};

export default Home;
